<div *ngIf="submitted" class="raptor-question-error">
  <div *ngFor="let error of fieldErrors | keyvalue">
    <mat-error *ngIf="error.key === 'required'">This question is required</mat-error>
    <mat-error *ngIf="error.key === 'email'">Please enter a valid email</mat-error>
    <mat-error *ngIf="error.key !== 'required' && error.key !== 'email'">
      <span *ngIf="!$any(error).value.layout && $any(error).value.message">{{ $any(error).value.message }}</span>

      <div
        *ngIf="$any(error).value.layout && $any(error).value.message"
        class="open-form-info error-box margin-bottom-small padding-medium"
        [innerHTML]="$any(error).value.message"
      >
      </div>
    </mat-error>
  </div>
</div>

<div class="raptor-question-error" *ngIf="questionControl && questionControl.errors && questionControl.errors.pageError">
  <mat-error *ngFor="let error of questionControl.errors.pageError">
    <div class="open-form-info error-box margin-bottom-small padding-medium" [innerHTML]="error"></div>
  </mat-error>
</div>
